import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CheckoutInfoPage } from './checkout-info.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutInfoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CheckoutInfoPageRoutingModule {}
